import {
    HTMLAttributes,
    useState,
     ReactElement,
     useEffect,
     useRef
} from "react";
import { Cancel, DangerSquare } from "../../assets";
import CustomModal from "./modal";

interface Props extends HTMLAttributes<HTMLElement> {
    value?: any;
    title?: string,
    onChange?: any;
    myStyle?: string;
    lable?: string;
    displayEmpty?: boolean;
    placeholder?: string;
    icon?: ReactElement;
    iconBorder?: boolean;
    hasNotice?: string;
    item?: any;
    isRequired?: boolean;
    disabled?:boolean;
    contentLoading?: boolean;

}
const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

export function CustomSelect({ value, onChange, title, myStyle, disabled, displayEmpty, placeholder, icon, iconBorder, hasNotice, isRequired, onClick, item, contentLoading }: Props): ReactElement {
    const ref :any = useRef(null);
    const [showDropDown, setShowDropDown] = useState(false);
    const [openModal, setOpenModal] = useState(false); // مدیریت نمایش مدال

    const handleOnClick = (item:any) => {

        if( !disabled){
            onChange && onChange(item);
            setShowDropDown(false)

        }
    }


    useEffect(() => {
        const checkIfClickedOutside = (e: { target: any; }) => {   
          if (showDropDown && ref.current && !ref.current.contains(e.target)) {
            setShowDropDown(false);
          }
        }
        document.addEventListener("mousedown", checkIfClickedOutside)
    
        return () => {
          document.removeEventListener("mousedown", checkIfClickedOutside)
        }
      }, [showDropDown])

    return (
        <div
            onClick={(e) => {
                const target = e.target as HTMLElement;
                if (!disabled && !openModal) {
                    setShowDropDown((prev) => !prev); // فقط در صورتی که مدال باز نباشه، دراپ‌داون رو باز یا بسته کن
                }
            }}
            className={`${myStyle && myStyle} ${value === undefined ? "" : "checked"} custom-select`}
            ref={ref}
        >
{contentLoading ?
                        <div className="w-100 content-loading input-loading-lable">
                        </div>
                        :
 <>
 <div className="custom-select-content"  >
                <div className="custom-select-content-clickable">
                    <span className={`${disabled ? "disabled" : ""} custom-select-placeholder`}>
                        {placeholder}
                    </span>
                {hasNotice && ( 
                                <img
                                    src={DangerSquare}
                                    alt="هامرز"
                                    className="ignore-click"    
                                    style={{ cursor: "pointer" }}
                                    onClick={(e) => {
                                        e.stopPropagation();   
                                        setShowDropDown(false);  // وقتی مدال باز میشه، دراپ‌داون بسته بشه
                                        setOpenModal(true);
                                    }}
                                />
                    )}
                </div>
                <div className="d-flex align-items-center">
                        <span className={`${disabled ? "disabled" : ""} custom-select-placeholder custom-select-selected ps-2`}>
                           {item?.type === "boolean" ? (value === true ? "بله" : "خیر") : value}
                        </span>
                    <div className="arrow arrow-up"></div>
                </div>
            </div>
            {showDropDown && !openModal && (
                <ul className="custom-select-list">
                    {item?.type === "boolean" ? (
                        <>
                           <li className="custom-select-list-item" onClick={() => handleOnClick(true)}>بله</li>
                                    <li className="custom-select-list-item" onClick={() => handleOnClick(false)}>خیر</li>
                                </>
                            ) : (
                                item?.values?.map((option: any, index: any) => (
                                    <li key={index} className="custom-select-list-item" onClick={() => handleOnClick(option)}>
                                        {option}
                             </li>
                            ))
                            )}
                        </ul>
                    )}
                </>
            }

<CustomModal myStyle="custom-input-modal" openModal={openModal} onClose={() =>setOpenModal(false)}>
          <>
            <div className="custom-modal-main-title hide-desktop">
              <h1 className="title">
              {placeholder}              </h1>
              <Cancel myStyle="ps-2 " width="20" height="20" color="#000000" onClick={() =>setOpenModal(false)} />
            </div>
            <div className="filter-selected">
              <div>
                <span className="text ml-50 hide-mobile bold">
                {placeholder}
                </span>{" "}
              </div>
              <Cancel myStyle="hide-mobile cursor-pointer" onClick={() =>setOpenModal(!openModal )} />
            </div>

            <h2 className="custom-input-modal-info mt-33">
           {hasNotice}
            </h2>
             
          </>
        </CustomModal>
        </div >
    );
}

export default CustomSelect;
